import moment from 'moment'

import {
  dateBackendDateTimeToBackend,
  dateBackendDateTimeToRelativeTime,
  dateBackendDateTimeToUI,
  diffBetweenDates,
} from 'modules/core/lib/dates'

const DAYS_CONSIDERED_RECENT = 5
export const timeAgoWhenRecent = (date: string) => {
  const today = dateBackendDateTimeToBackend(moment().toISOString())
  const differenceBetweenDates = diffBetweenDates(today, dateBackendDateTimeToBackend(date))
  const hasADayPassed = differenceBetweenDates >= DAYS_CONSIDERED_RECENT

  return hasADayPassed ? dateBackendDateTimeToUI(date) : dateBackendDateTimeToRelativeTime(date)
}
